import { useT } from "@/3-features/i18n/useT";

/**
 * "Skip to content", visually hidden until focused.
 *
 * Every route has a sticky header with a multi-item dropdown nav, so without
 * this a keyboard user tabs through the whole navigation again on every page
 * before reaching anything the page is actually about.
 *
 * The target is the `<main id="main">` that `App` (and `LandingPage`, which
 * renders outside App's chrome) provides.
 */
export function SkipLink() {
  const { t } = useT();
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-dec-green focus:px-5 focus:py-3 focus:text-sm focus:font-semibold focus:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-dec-green"
    >
      {t("skipToContent")}
    </a>
  );
}
